import builder from '../builder';
import Hyperlink3 from '../../streamline-icons/bold/hyperlink-3.svg';

export default builder('IconHyperlink3Bold', Hyperlink3);
